import "./App.css";
import { ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import theme from "./theme";
import Home from "./components/Home";
import Contract from "./components/contracts/Contract";
import PreContract from "./components/contracts/PreContract";
import Completed from "./components/contracts/Completed";
import NspWizard from "./components/nsp/NspWizard";
import Confirmation from "./components/nsp/Confirmation";
import WrongDetails from "./components/contracts/WrongDetails";
import Apply from "./components/apply/Apply";
import NotFound from "./components/NotFound";
import TrialWizard from "./components/trial/TrialWizard";

function App() {
    return (
        <ThemeProvider theme={theme}>
            <CssBaseline />
            <div className="App">
                <BrowserRouter>
                    <Routes>
                        <Route path="/" element={<Home />} />
                        <Route path="apply" element={<Apply />} />
                        <Route path="nsp" element={<NspWizard />} />
                        <Route path="nsp/confirm" element={<Confirmation />} />
                        <Route path="trial" element={<TrialWizard />} />
                        <Route path="contract" element={<Contract />} />
                        <Route
                            path="contract-confirmation"
                            element={<PreContract />}
                        />
                        <Route path="contract-completed" element={<Completed />} />
                        <Route path="wrong-details" element={<WrongDetails />} />
                        <Route path="*" element={<NotFound />} />
                    </Routes>
                </BrowserRouter>
            </div>
        </ThemeProvider>
    );
}

export default App;
